// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"f50ce114","198":"af56a2df","605":"3bfb60a4","649":"308939ce","787":"2973425a","985":"07d58a69"}[chunkId] + ".chunk.js";
};